module.exports = __webpack_public_path__ + "static/media/download-longpress.61c112a7.svg";